import type { FilterParams, SortParams } from "epsm-api-types";

export enum StockScannerUniverse {
	LIQUID_US = "LIQUID_US",
	TOP_500 = "TOP_500",
	LARGE_MID_CAPS = "LARGE_MID_CAPS",
	SMALL_MICRO_CAPS = "SMALL_MICRO_CAPS",
	ETF_LIQUID = "ETF_LIQUID",
	ALL_STOCKS = "ALL_STOCKS",
}

export enum StockScannerEvent {
	MOST_UP = "MOST_UP",
	MOST_DOWN = "MOST_DOWN",
	MOST_UP_CLOSE_TO_CLOSE = "MOST_UP_CLOSE_TO_CLOSE",
	MOST_DOWN_CLOSE_TO_CLOSE = "MOST_DOWN_CLOSE_TO_CLOSE",
	EARNINGS_MOMENTUM = "EARNINGS_MOMENTUM",
	NEW_52W_HIGHS = "NEW_52W_HIGHS",
	NEW_52W_LOWS = "NEW_52W_LOWS",
	POWERDAY_POSITIVE_BREAKOUTS = "POWERDAY_POSITIVE_BREAKOUTS",
	POWERDAY_NEGATIVE_BREAKOUTS = "POWERDAY_NEGATIVE_BREAKOUTS",
	UP_SLOPING_TRENDING = "UP_SLOPING_TRENDING",
	DOWN_SLOPING_TRENDING = "DOWN_SLOPING_TRENDING",
	WALL_STREET_FAVS = "WALL_STREET_FAVS",
	PRICE_TARGET_RAISED = "PRICE_TARGET_RAISED",
	REVISION_WINNERS = "REVISION_WINNERS",
	RELATIVE_STRENGTH = "RELATIVE_STRENGTH",
	GARP = "GARP",
	CAPITAL_EFFICIENCY = "CAPITAL_EFFICIENCY",
	HIGH_GROWTH = "HIGH_GROWTH",
	INCOME_BEST = "INCOME_BEST",
	VALUE_PLAYS = "VALUE_PLAYS",
	ACCELERATING = "ACCELERATING",
	DECELERATING = "DECELERATING",
	TIMING_MOMENTUM = "TIMING_MOMENTUM",
	UPDRIFT = "UPDRIFT",
	POWERDAYS = "POWERDAYS",
	UP_VOLUME = "UP_VOLUME",
	DOWN_VOLUME = "DOWN_VOLUME",
	RELATIVE_WEAKNESS = "RELATIVE_WEAKNESS",
}

export type StockScannerUniverseOption = {
	label: string;
	filter: FilterParams;
};

export type StockScannerEventOption = {
	label: string;
	fields: string[];
	filter: FilterParams;
	sort?: SortParams;
	text?: string;
	image?: string;
};

export type StockScannerFundamental =
	| StockScannerEvent.WALL_STREET_FAVS
	| StockScannerEvent.PRICE_TARGET_RAISED
	| StockScannerEvent.REVISION_WINNERS
	| StockScannerEvent.RELATIVE_STRENGTH
	| StockScannerEvent.GARP
	| StockScannerEvent.CAPITAL_EFFICIENCY
	| StockScannerEvent.HIGH_GROWTH
	| StockScannerEvent.INCOME_BEST
	| StockScannerEvent.VALUE_PLAYS
	| StockScannerEvent.ACCELERATING
	| StockScannerEvent.DECELERATING
	| StockScannerEvent.RELATIVE_WEAKNESS;

export type StockScannerPriceAction =
	| StockScannerEvent.MOST_UP
	| StockScannerEvent.MOST_DOWN
	| StockScannerEvent.MOST_UP_CLOSE_TO_CLOSE
	| StockScannerEvent.MOST_DOWN_CLOSE_TO_CLOSE
	| StockScannerEvent.NEW_52W_HIGHS
	| StockScannerEvent.NEW_52W_LOWS
	| StockScannerEvent.POWERDAY_POSITIVE_BREAKOUTS
	| StockScannerEvent.POWERDAY_NEGATIVE_BREAKOUTS
	| StockScannerEvent.UP_SLOPING_TRENDING
	| StockScannerEvent.DOWN_SLOPING_TRENDING
	| StockScannerEvent.UP_VOLUME
	| StockScannerEvent.DOWN_VOLUME;

export type StockScannerShowcase =
	| StockScannerEvent.EARNINGS_MOMENTUM
	| StockScannerEvent.TIMING_MOMENTUM
	| StockScannerEvent.UPDRIFT
	| StockScannerEvent.POWERDAYS;
